import React from 'react'
import image from '../../assets/homepage_ps6.png'
import image2 from '../../assets/homepage_ps7.png'
import image3 from '../../assets/homepage_ps8.png'
const OfferBanner = () => {
    return (
        <>
            <div className="row mt-5 cstm-padding">
                <div className="col-md-4">
                    <div className="box1 bg-sky">
                        <div className="bx-txt">
                            <h4>
                                $645.00 <span>$759.99</span>
                            </h4>
                            <h3>
                                Sale Up To <span>25% Off</span> Bosch Home
                            </h3>
                            <a href="#" className="btn-buy">
                                BUY NOW
                            </a>
                        </div>
                        <div className="bx-img">
                            <img className="img-fluid" src={image} alt="" />
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="box1 bg-sky">
                        <div className="bx-txt">
                            <h4>
                                $345.00 <span>$429.99</span>
                            </h4>
                            <h3>
                                Extra <span>30% Off</span> All Sale Style
                            </h3>
                            <a href="#" className="btn-buy">
                                BUY NOW
                            </a>
                        </div>
                        <div className="bx-img">
                            <img className="img-fluid" src={image2} alt="" />
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="box1 bg-sky">
                        <div className="bx-txt">
                            <h4>
                                $275.00 <span>$329.99</span>
                            </h4>
                            <h3>
                                iPATROL <span>Riley V2</span> Bonus Bundle
                            </h3>
                            <a href="#" className="btn-buy">
                                BUY NOW
                            </a>
                        </div>
                        <div className="bx-img">
                            <img className="img-fluid" src={image3} alt="" />
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default OfferBanner